import { useSearch } from "~/core/composables/useSearch";
import LxcError from "~/core/models/LxcError.class";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.type";
import {
  Filters,
  type FiltersSelection,
  FiltersType,
  OPERATOR_RSQL_IN,
} from "~/core/models/filters";
import type { DtwinMetricsByModelFriendlyName } from "~/modules/dashboard/models/DtwinMetricsByModelFriendlyName.type";
import type { DtwinMetricsCounts } from "~/modules/dashboard/models/DtwinMetricsCounts.type";
import dtwinService from "~/modules/dtwin/services/dtwin.service";

export function useFetchDtwinMetricsLifeCycleState({
  organizationCode,
}: UseFetchParameters) {
  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.SECTORS,
      { key: "sectorCode", operator: OPERATOR_RSQL_IN, value: [] },
    ],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
  );

  const isLoading = ref(false);
  const results: Ref<
    DtwinMetricsByModelFriendlyName<DtwinMetricsCounts> | undefined
  > = ref();
  const error: Ref<LxcError | undefined> = ref();

  async function fetchData() {
    isLoading.value = true;
    results.value = undefined;
    error.value = undefined;

    const response = await dtwinService.getDtwinsMetricsLifeCycleState(
      organizationCode,
      searchParams.value,
    );

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      results.value = response;
    }
    isLoading.value = false;
  }

  return {
    filters,
    setFilter,
    search,
    onSearch,
    isLoading,
    results,
    error,
    fetchData,
  };
}
